import {useState} from 'react'

import FarmerDetailsForm from './FarmerDetailsForm';
import FarmerDetailsList from './FarmerDetailsList';

const FarmerDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <FarmerDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FarmerDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}



export default FarmerDetails